// Request identifiers provide retry safety, not authorization or secret material.
let sequence = 0;
export const requestKey = () => {
  const cryptoApi = globalThis.crypto;
  if (cryptoApi?.randomUUID) return cryptoApi.randomUUID();
  if (cryptoApi?.getRandomValues) return Array.from(cryptoApi.getRandomValues(new Uint8Array(16)), n => n.toString(16).padStart(2, "0")).join("");
  // Older browsers/test runtimes: server uniqueness rejects any collision.
  return `${Date.now().toString(36)}-${++sequence}-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`;
};
